import _ from "lodash";
import React, { useMemo } from "react";
import { useI18n } from "Hooks";
import { connect } from "react-redux";

import { SegmentControl } from "@toddle-edu/ds-web";
import { getIsAITutorModalitiesEnabled } from "Utils/ACLStoreUtils";

import { updateAIDataInRedux } from "Assessments/modules/AssessmentModule";
import { getAssessmentDetailsFromCache } from "Assessments/modules/AssessmentGraphqlHelpers";

import {
  ASSESSMENT_TYPE_AI_TUTOR,
  TASK_TYPE_AI_TUTOR,
} from "Constants/stringConstants";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";

import classes from "./AITutorSegmentControl.scss";

const CHAT = "CHAT";
const TASK_DETAILS = "TASK_DETAILS";

const AI_TUTOR_TAB_OPTIONS = [
  {
    label: "common:create",
    value: CHAT,
  },
  {
    label: "common:configure",
    value: TASK_DETAILS,
  },
];

const AITutorSegmentControl = props => {
  const {
    testId = "appComponents",
    selectedTab,
    assessmentType,
    showAITutorSelectedTab,
    taskTypeGroup,
  } = props;

  const { t } = useI18n();

  const options = useMemo(() => {
    return _.map(AI_TUTOR_TAB_OPTIONS, option => ({
      ...option,
      label: t(option.label),
    }));
  }, [t]);

  const updateSelectedTab = tab => {
    props.updateAIDataInRedux({ aiTutorSelectedTab: tab });
  };

  if (
    !assessmentType ||
    (assessmentType !== ASSESSMENT_TYPE_AI_TUTOR &&
      taskTypeGroup !== TASK_TYPE_AI_TUTOR)
  ) {
    return null;
  }

  return getIsAITutorModalitiesEnabled() && showAITutorSelectedTab ? (
    <div className={classes.segmentControl}>
      <SegmentControl
        dsVersion={"2.0"}
        size={"medium"}
        options={options}
        value={selectedTab}
        onChange={updateSelectedTab}
        testId={`${testId}-segmentControl`}
      />
    </div>
  ) : null;
};

const mapStateToProps = (state, ownProps) => {
  const { assessmentId } = ownProps;

  const aiData = _.get(state, "assessment.aiData", {});
  const selectedTab = _.get(aiData, "aiTutorSelectedTab");
  const showAITutorSelectedTab = _.get(aiData, "showAITutorSelectedTab", true);

  const assessmentDetails = getAssessmentDetailsFromCache({
    id: assessmentId,
    collaboratorsFilter: {
      userAcademicYearId: getSelectedAcademicYearId(state),
    },
  });

  const assessmentType = _.get(assessmentDetails, "assessmentType.value", null);

  const taskTypeGroup = _.get(assessmentDetails, "taskType.type", null);

  return {
    selectedTab,
    assessmentType,
    showAITutorSelectedTab,
    taskTypeGroup,
  };
};

const mapActionCreators = {
  updateAIDataInRedux,
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(AITutorSegmentControl);
